import { NativeDateAdapter } from '@angular/material/core';

export class CustomDateAdapter extends NativeDateAdapter {
  override parse(value: any): Date | null {
    if (!value) return null;

    if (typeof value === 'string') {
      const digitsOnly = value.replace(/\D/g, '');

      if (digitsOnly.length > 0 && digitsOnly.length < 8) {
        return new Date(NaN);
      }

      const match = /^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/.exec(value);
      if (!match) {
        return new Date(NaN);
      }

      const day = Number(match[1]);
      const month = Number(match[2]) - 1;
      const year = Number(match[3]);

      if (month < 0 || month > 11 || day < 1 || day > 31) {
        return new Date(NaN);
      }

      const date = new Date(year, month, day);

      if (date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day) {
        return new Date(NaN);
      }

      return date;
    }

    return value instanceof Date ? value : null;
  }

  override deserialize(value: any): Date | null {
    if (!value) return null;

    if (typeof value === 'string') {
      return this.parse(value);
    }

    return value instanceof Date ? value : null;
  }

  override format(date: Date, displayFormat: string): string {
    if (displayFormat === 'DD-MM-YYYY') {
      return `${this._two(date.getDate())}-${this._two(date.getMonth() + 1)}-${date.getFullYear()}`;
    }

    if (displayFormat === 'MMM YYYY') {
      return new Intl.DateTimeFormat('en-GB', {
        month: 'short',
        year: 'numeric',
      }).format(date);
    }

    if (displayFormat === 'MMMM YYYY') {
      return new Intl.DateTimeFormat('en-GB', {
        month: 'long',
        year: 'numeric',
      }).format(date);
    }

    return super.format(date, displayFormat);
  }

  private _two(n: number): string {
    return n < 10 ? '0' + n : '' + n;
  }
}
